import React, { ReactElement, useState } from 'react';
import './filter.scss';
import { Heading, usePageNumberFromUrl, usePerPageValueFromUrl } from 'idsk-react-components';
import { useNavigate, useParams } from 'react-router';
import useFilter from './hook/useFilter';
import routes from '../../routing/routes';
import PripomienkyListFilter from '../../model/filter/PripomienkyListFilter';
import FilterData from '../../model/filter/FilterData';
import FilterForm from './component/FilterForm';
import { defaultPerPageValue, perPageDataArray } from '../../constants/PaginationPerPageConstants';
import NahladVyhodnoteniaPkButton from '../ActionButton/component/NahladVyhodnoteniaPkButton';
import { useUserContext } from '../../context/UserContext';
import useOdoslanaPripomienkaExists from '../../hooks/useOdoslanaPripomienkaExists';
import ClassType from '../../model/pripomienka/ClassType';
import UserRole from '../../model/currentuser/UserRole';

interface Props {
  filter: PripomienkyListFilter,
  filterData: FilterData,
  isHromadna?: boolean,
}

const Filter = ({
  filter,
  filterData,
  isHromadna = false,
}: Props): ReactElement => {
  const { page } = usePageNumberFromUrl('page');
  const { perPageValue } = usePerPageValueFromUrl('perPage', perPageDataArray, defaultPerPageValue);
  const {
    type, year, index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();
  const navigate = useNavigate();
  const { pouzivatel } = useUserContext();
  const [fetchOdoslanaExists, setFetchOdoslanaExists] = useState<boolean>(true);

  const {
    setText, text, from, setFrom, to, setTo, typ, setTyp,
    stav, setStav, priradeny, setPriradeny, pripomienkujuciSubjekt,
    setPripomienkujuciSubjekt, resetFilterHandler, targetUrl, isSelectedFilter,
  } = useFilter(
    isHromadna,
    page,
    perPageValue,
    filter,
    isHromadna
      ? routes.hromadnePripomienky.list.withParams(type, year, index)
      : routes.pripomienky.list.withParams(type, year, index),
    filterData,
    fetchOdoslanaExists,
    setFetchOdoslanaExists,
  );
  const [formOpen, setFormOpen] = useState<boolean>(isSelectedFilter);

  const onSubmit = async (event): Promise<void> => {
    event.preventDefault();
    setFetchOdoslanaExists(!fetchOdoslanaExists);
    navigate(targetUrl);
  };

  const pouzivatelHasCertainRole = ()
      : boolean => !!pouzivatel && (pouzivatel.opravnenia?.includes(UserRole.SUPERADMIN)
      || pouzivatel.opravnenia?.includes(UserRole.VYHODNOCOVATEL));

  const {
    odoslanaPripExists,
  } = useOdoslanaPripomienkaExists(isHromadna ? ClassType.HROMADNA_PRIPOMIENKA
    : ClassType.PRIPOMIENKA, filter, pouzivatelHasCertainRole(), fetchOdoslanaExists);

  return (
    <div className="sprava-pripomienok-filter">
      <Heading size="m" className="filter-title">Filtrovať zoznam</Heading>
      <button
        type="button"
        className="filter-toggle"
        onClick={() => setFormOpen(!formOpen)}
      >
        {(formOpen) ? 'Zbaliť obsah filtra' : 'Rozbaliť obsah filtra'}
      </button>
      {
            formOpen && (
            <>
              <FilterForm
                isHromadna={isHromadna}
                text={text}
                setText={setText}
                from={from}
                setFrom={setFrom}
                to={to}
                setTo={setTo}
                typ={typ}
                setTyp={setTyp}
                stav={stav}
                setStav={setStav}
                pripomienkujuciSubjekt={pripomienkujuciSubjekt}
                setPripomienkujuciSubjekt={setPripomienkujuciSubjekt}
                priradeny={priradeny}
                setPriradeny={setPriradeny}
                resetFilterHandler={resetFilterHandler}
                onSubmit={onSubmit}
              />
              <NahladVyhodnoteniaPkButton
                useFilter
                buttonName="Náhľad pre vyhodnotenie PK (vyfiltrované)"
                setOpenDropdown={null}
                isHromadna={isHromadna}
                existOdoslana={odoslanaPripExists}
              />
            </>
            )
        }
    </div>
  );
};

export default Filter;
